import React from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
var AvailabilitySelected = inject(AvailabilityBusiness)(observer(function (props) {
    var selectedAvailabilityTimes = props.selectedAvailabilityTimes, clearAvailabilityTime = props.clearAvailabilityTime, calendarDate = props.calendarDate, _a = props.showSlot, showSlot = _a === void 0 ? true : _a;
    return React.createElement("div", { className: 'pt-4' },
        showSlot && React.createElement("div", { className: 'ft-18' },
            React.createElement("b", { className: 'title' }, "Selected available times:")),
        React.createElement("div", { className: 'mt-2' }, selectedAvailabilityTimes.map(function (item, index) { return (React.createElement("div", { className: 'w-100 mb-10' },
            !item.isActive && showSlot && React.createElement("div", { className: 'dsm-card' },
                React.createElement("div", { className: 'dsm-card-body p-0 d-flex align-items-center justify-content-center no-selected' },
                    item.availabilityTime,
                    " ",
                    index + 1)),
            item.isActive && React.createElement("div", { className: 'selected-availability d-flex justify-content-between align-items-center px-2' },
                React.createElement("div", { className: 'col-3' },
                    React.createElement("b", null, item.formatDate)),
                React.createElement("div", { className: 'col-8 d-flex justify-content-between' },
                    React.createElement("div", { className: '' },
                        React.createElement("b", null, item.timeQuantumId)),
                    React.createElement("div", { className: 'selected-timequantum' }, item.timeQuantumValue)),
                React.createElement("div", { className: 'col-1 d-flex justify-content-center' },
                    React.createElement("i", { className: 'ds ds-remove cp', onClick: function () { return clearAvailabilityTime(index, calendarDate); } }))))); })));
}));
export default AvailabilitySelected;
